export default __webpack_public_path__ + "static/media/Snd_H_Starts.f408f0f7.mp3";